// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"e51da1d1","630":"5a301230"}[chunkId] + ".chunk.css";
};